<template>
  <v-row
    style="background-color: #fff; border-radius: 20px"
    class="text-center primary--text d-flex align-center mb-8"
  >
    <v-col cols="3" class="d-flex align-center justify-center">
      <icon
        v-if="token && token.icon !== null"
        width="40"
        :name="token.icon"
      ></icon>
      <v-icon v-else size="x-large" class="my-2" color="primary"
        >shopping_bag</v-icon
      >
    </v-col>
    <v-col cols="5">
      <v-row>
        <span>{{ token.name }}</span>
      </v-row>
    </v-col>
    <v-col
      cols="4"
      class="primary--text font-weight-bold d-flex align-center justify-end fill-height"
      style="border-top-right-radius: 20px; border-bottom-right-radius: 20px"
    >
      <span class="pr-3">
        {{ token.amount }}
        <v-icon size="large" class="mb-1" color="primary">star</v-icon>
      </span>
    </v-col>
  </v-row>
</template>

<script lang="ts">
export default {
  props: {
    token: {
      type: Object,
      required: true,
    },
  },
};
</script>
